import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class StrategyBuilderService {

    constructor(public http: HttpClient, public AppConfig: AppConfig){}

    getMockDetails(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/cat-strategy/v1/mock/get?query='+reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  getMockDataFromMocks(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/mbr/mock/v1/analytics/'+reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }


}